module.exports = __webpack_public_path__ + "media/images/Formation du personnel-953c4b21be6e1246fe7e3d28089b3e9f.svg";